import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('SettingsModule', [
      'orgId',
    ]),

    ldapDN() {
      return username => (username && username.length > 0) && `uid=${username},ou=Users,o=${this.orgId},dc=jumpcloud,dc=com`;
    },
  },
};
